import React, { useRef } from 'react';
import "./notifications.scss";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import useClickOutside from '../../../utils/useClickOutside';
import useNotifications from './useNotifications';
import NotificationList from './NotificationList';
import UseScreenSize from '../../../utils/UseSizeScreen';
import { useHistory } from 'react-router-dom';

const Notifications = () => {
  const { width } = UseScreenSize();
  const history = useHistory();
  const isMobile = width <= 1024;
  const ref = useRef();

  const {
    notifications,
    notificationCounts,
    params,
    loading,
    isOpen,
    expandedNotificationIndex,
    totalUnread,
    parsedNotificationsArr,
    notificationListRef,
    notificationTypes,
    markRead,
    setMarkRead,
    handleParamsChange,
    handleExpandClick,
    closeMenu,
    onOpen,
    getNotificationGroup,
    t
  } = useNotifications();

  useClickOutside(ref, () => {
    if (!isMobile) {
      closeMenu();
    }
  });

  const handleBellClick = () => {
    if (isMobile) {
      history.push('/notifications');
    } else {
      if (isOpen) {
        closeMenu();
      } else {
        onOpen();
      }
    }
  };

  return (
    <div ref={ref} className='notification-center'>
      <div className='notification-toggle' onClick={handleBellClick}>
        <div className="nav-link notif-bell d-flex">
          <FontAwesomeIcon icon={faBell} />
        </div>
        {totalUnread > 0 && (
          <div className="notification-toggle-indicator">{totalUnread}</div>
        )}
      </div>
      {!isMobile && (
        <div className={`notification-menu ${isOpen ? 'open' : ''}`}>
          <div className='notification-menu-header border-bottom'>
            <h2 className='p-0 m-0'>{t("navbar.notifications", "Notifications")}</h2>
            <div className="d-flex align-items-center gap-3 justify-content-center">
              <div className="custom-control custom-switch d-flex align-items-center">
                <input
                  checked={params.read === "false"}
                  onChange={(e) => handleParamsChange("read", e.target.checked ? "false" : null)}
                  type="checkbox"
                  id="show_only_unread"
                  name="show_only_unread"
                  className="custom-control-input"
                />
                <label className="custom-control-label unread-text" htmlFor="show_only_unread">
                  {t("navbar.showOnlyUnread", "Show only unread")}
                </label>
              </div>
            </div>
          </div>
          <NotificationList
            notifications={notifications}
            notificationCounts={notificationCounts}
            params={params}
            loading={loading}
            expandedNotificationIndex={expandedNotificationIndex}
            parsedNotificationsArr={parsedNotificationsArr}
            notificationListRef={notificationListRef}
            notificationTypes={notificationTypes}
            markRead={markRead}
            setMarkRead={setMarkRead}
            handleParamsChange={handleParamsChange}
            handleExpandClick={handleExpandClick}
            getNotificationGroup={getNotificationGroup}
            isFullPage={false}
            t={t}
          />
        </div>
      )}
    </div>
  );
};

export default Notifications;
